var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedUserWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_493_4759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9673 1.15687L3.96734 4.26687C3.24734 4.58687 2.77734 5.30688 2.77734 6.09688V10.7969C2.77734 16.3469 6.61734 21.5369 11.7773 22.7969C16.9373 21.5369 20.7773 16.3469 20.7773 10.7969V6.09688C20.7773 5.30688 20.3073 4.58687 19.5873 4.26687L12.5873 1.15687C12.0773 0.926875 11.4773 0.926875 10.9673 1.15687ZM9.06734 16.0869L6.47734 13.4969C6.08734 13.1069 6.08734 12.4769 6.47734 12.0869C6.86734 11.6969 7.49734 11.6969 7.88734 12.0869L9.77734 13.9669L15.6573 8.08687C16.0473 7.69688 16.6773 7.69688 17.0673 8.08687C17.4573 8.47687 17.4573 9.10687 17.0673 9.49687L10.4773 16.0869C10.0973 16.4769 9.45734 16.4769 9.06734 16.0869Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_493_4759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.472656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedUserWhite);
export default __webpack_public_path__ + "static/media/VerifiedUserWhite.9195c9a839c8d5f974c0b0246fc60e30.svg";
export { ForwardRef as ReactComponent };